import { useSearchParams } from 'next/navigation'
import { useCallback, useMemo } from 'react'
import { searchParamsToObject } from '@/utils/search-params-to-obj'
import { createInitialFilters } from '@/utils/create-initial-filters'
import { useClientLocale } from '@/hooks/use-locale-config'

export const useInitialFilters = () => {
  const searchParams = useSearchParams()
  const locale = useClientLocale()

  const factory = useCallback(() => {
    const spObj = searchParamsToObject(searchParams)
    return createInitialFilters({ searchParams: spObj, locale })
  }, [locale, searchParams])

  return useMemo(() => factory(), [factory])
}
